// extracted by mini-css-extract-plugin
export var lg = "_er-7";
export var md = "_er-6";
export var placeholderContainer = "_er-1";
export var placeholderIcon = "_er-2";
export var productImage = "_er-0";
export var sm = "_er-5";
export var xl = "_er-8";
export var xs = "_er-4";
export var xxs = "_er-3";